import { useCallback, useRef, useState } from "react";

export function useUpdate(): () => void {
  // eslint-disable-next-line no-unused-vars
  const [_, setValue] = useState(true);
  const valueRef = useRef(true);
  return useCallback(() => {
    valueRef.current = !valueRef.current;
    setValue(valueRef.current);
  }, [valueRef, setValue]);
}
